import React, { useState, useRef } from 'react';

import PropTypes from 'prop-types';
import Slider from 'react-slick';

import '../../styles/revamp/referral-customer-cases.scss';

const ConfidentSmileSection = (props) => {
  const { translations } = props;

  const sliderRef = useRef(null);

  const [activeSlide, setActiveSlide] = useState(0);

  const confidentSmileSlider = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesPerScroll: 1,
    swipe: true,
    beforeChange: (current, next) => { setActiveSlide(next); },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.25
        }
      },
      {
        breakpoint: 986,
        settings: {
          slidesToShow: 1.4
        }
      },
      {
        breakpoint: 768,
        settings: {
          fade: true,
          slidesToShow: 1
        }
      }
    ]
  };

  const sliderContents = [
    {
      testimonial: translations.cards.card1.testimonial,
      customer: translations.cards.card1.customer_name,
      img: 'Sean'
    },
    {
      testimonial: translations.cards.card2.testimonial,
      customer: translations.cards.card2.customer_name,
      img: 'Zhiyu'
    },
    {
      testimonial: translations.cards.card3.testimonial,
      customer: translations.cards.card3.customer_name,
      img: 'Gary'
    }
  ];

  return (
    <section className="confident-smile-section">
      <h2
        className="heading"
        data-key="referral::confident_smile_section::heading"
        data-lokalise=""
      >
        {translations.heading}
      </h2>
      <p
        className="description"
        data-key="referral::confident_smile_section::sub_heading"
        data-lokalise=""
      >
        {translations.sub_heading}

      </p>
      <Slider {...confidentSmileSlider} className="confident-smile-slider" ref={sliderRef}>
        {sliderContents.map((content, index) => (
          <div className="smile-card-wrapper" key={content.customer_name}>
            <div className="smile-card">
              <img
                src={`/img/referral/confident-smile/confident-smile-${content.img}.png`}
                data-gumlet="false"
                alt={`Confident Smile - ${content.img}`}
              />
              <p
                data-key={`referral::confident_smile_section::cards::card${index + 1}::testimonial`}
                data-lokalise=""
              >
                {content.testimonial}
                <span
                  data-key={`referral::confident_smile_section::cards::card${index + 1}::customer_name`}
                  data-lokalise=""
                >
                  —
                  {' '}
                  {content.customer}
                </span>
              </p>
            </div>
            <div className="slider-arrows">
              <img
                src="/img/referral/chevron-right.svg"
                className={`slider-arrow slider-arrow-prev ${activeSlide === 0 ? 'disabled' : ''}`}
                data-gumlet="false"
                alt="prev-arrow"
                role="presentation"
                onClick={() => sliderRef.current.slickPrev()}
              />
              <img
                src="/img/referral/chevron-right.svg"
                className={`slider-arrow slider-arrow-next 
                ${activeSlide === sliderContents.length - 1 ? 'disabled' : ''}`}
                data-gumlet="false"
                alt="next-arrow"
                role="presentation"
                onClick={() => sliderRef.current.slickNext()}
              />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default ConfidentSmileSection;

ConfidentSmileSection.propTypes = {
  translations: PropTypes.shape().isRequired
};
